/** Shared by cached queries, imperative requests, and downloads. */
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:9001/api';
